import { CreateOrUpdateUserAsAdmin } from "src/common/components/CreateOrUpdateUserAsAdmin/CreateOrUpdateUserAsAdmin";

const CreateCollaborator = () => {
  return <CreateOrUpdateUserAsAdmin mode="create" userRole="creator" />;
};

export default CreateCollaborator;
